import React, { ReactElement } from 'react';
import { BooleanFieldProps } from './editable/BooleanField';
import { StringDisplayProps } from './static/StringDisplay';

type AllowedTypes = BooleanFieldProps | StringDisplayProps;

export interface DataTableEntryProps {
  children: ReactElement<AllowedTypes> | ReactElement<AllowedTypes>[];
}

const DataTableRow: React.FC<DataTableEntryProps> = ({ children }) => {
  return <tr className='whitespace-nowrap'>{children}</tr>;
};

export default DataTableRow;
